<template>
  <div class="ide">
    <Layout
      direction="row"
      :min="200"
      :max="1000"
      :drag-width.sync="dragWidth"
    >
      <template v-slot:global-attribute>
        <PropTable :props="props"/>
      </template>
      <template v-slot:menu>
        <IDETree ref="tree" :template-id="templateId" :files="files" @open-file="openFile"/>
      </template>
      <template v-slot:codespace>
        <IDECodeSpace :files="openedFiles"/>
      </template>
    </Layout>
  </div>
</template>

<script>
import Layout from './Layout'
import IDETree from './tree/index'
import IDECodeSpace from './codespace/index'
import PropTable from './prop/PropTable'
export default {
  name: 'IDE',
  components: { PropTable, IDECodeSpace, IDETree, Layout },
  props: {
    // 模版ID
    templateId: {
      required: true
    },
    // 全局属性列表
    props: {},
    // 文件列表
    files: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      dragWidth: 300,
      openedFiles: []
    }
  },
  methods: {
    // 打开文件
    openFile ({ file, openedFiles }) {
      this.openedFiles = openedFiles
    },
    // 获取所有模版文件
    getTemplateFiles () {
      return this.$refs.tree.getTemplateFiles()
    }
  },
  created () {
    document.body.setAttribute('class', 'ide-body')
  }
}
</script>

<style lang="scss">
@import "./icons/iconfont";
@import "./langs/langs";
@import "./variables";
// 确认窗口
.ide-message-box {
  background-color: $menu-background;
  border-color: $menu-background + 5;
  .el-message-box__message {
    color: $color-white;
  }
}
.ide-body {
  // 下拉框
  .el-select-dropdown {
    background-color: $code-space-background;
    border-color: $code-space-background + 10;
    .popper__arrow {
      border-bottom-color: $code-space-background;
    }
    .el-select-dropdown__item {
      color: $color-white;
      &.selected {
        background-color: $code-space-background;
      }
      &.hover {
        background-color: $menu-background;
      }
    }
  }
  // 弹窗
  .el-popper {
    &[x-placement^="bottom"] .popper__arrow {
      border-bottom-color: $code-space-background + 10;
      &::after {
        border-bottom-color: $code-space-background;
      }
    }
  }
}
.ide, .ide-dialog {
  // 默认按钮
  .el-button--default {
    color: $primary-color;
    background-color: #eee;
    border: 0;
  }
  // 主按钮
  .el-button--primary {
    background-color: $primary-color;
    color: $color-white;
    &:hover {
      background-color: $primary-color + 5;
    }
  }
  // 输入框
  .el-input__inner, .el-textarea__inner{
    transition: all ease .15s;
    background-color: $input-background;
    border: 1px solid $input-background + 10;
    color: $color-white;
  }
  // 下拉框
  .el-select {
    border: 0;
    .el-input__inner {
      border: 0;
    }
  }
}
</style>

<style scoped lang="scss">
@import "variables";
.ide {
  height: 100%;
  min-width: 1080px;
  overflow-x: auto;
  background-color: $menu-background;
}
</style>
